<template>
  <div>
    <b-modal
      ref="my-modal"
      centered
      hide-footer
      hide-header
      no-close-on-backdrop
      no-close-on-esc
      title="Using Component Methods"
    >
      <a
        class="btn-close"
        href="/login"
      >
        <img
          :src="require('@/assets/images/close.png')"
          alt=""
        >
      </a>
      <div class="d-block text-center">
        <img
          :src="require('@/assets/images/success.png')"
          alt="Success"
          class="img-success-register"
        >
      </div>
      <div class="modal-text">
        <h4>
          Thank you for choosing IOH
        </h4>
        <p>
          The document validation will take up to 2x24 hours. The success notification will be sent to your given email and sms inbox.
        </p>
      </div>
    </b-modal>
  </div>
</template>

<script>
import {
  BModal,
} from 'bootstrap-vue'

export default {
  components: {
    BModal,
  },
  methods: {
    showModal() {
      this.$refs['my-modal'].show()
    },
  },
}
</script>
<style scoped>
.btn-close {
  position: absolute !important;
  right: 18px;
  top: 14px;
}
.img-success-register {
  margin-top: 43px;
}
.modal-text {
  text-align: center;
  font-family: 'Rubik';
  margin-top: 18px;
  margin-bottom: 40px
}

.modal-text > h4 {
  font-weight: bold;
  color: #000;
  margin-bottom: 0;
}

.modal-text > p {
  margin-top: 15px;
}
</style>
